import { plainToInstance } from 'class-transformer';
import { GetServerSideProps, InferGetServerSidePropsType } from 'next';

import Map from '@/components/Map';
import OtherPlacesForecastWidget from '@/components/OtherPlacesForecastWidget';
import Meta from '@/layouts/Meta';
import { OtherPlaceForecast } from '@/models/OtherPlaceForecast';
import { AllForecastsJsonType, getAllForecasts } from '@/providers/ForecastProvider';
import Main from '@/templates/Main';
import NpsWidgetScript, { NpsTypes } from '@/templates/NpsWidgetScript';
import { AppConfig } from '@/utils/AppConfig';
import { useStepEvent } from '@/utils/hooks/UseStepEvent';
import { completeSeoData, SeoData } from '@/utils/Seo';
import { SeoPlaceholders } from '@/utils/SeoPlaceholders';

type SatelliteProps = {
  forecasts: AllForecastsJsonType;
  seo: SeoData;
};

const rawSeoData: SeoData = {
  title: `Карта осадков и ветров ${SeoPlaceholders.SUBJECT_GENITIVE} в реальном времени`,
  description: `Карта осадков, ветра и температуры ${SeoPlaceholders.SUBJECT_GENITIVE} с обновлением данных в реальном времени.`,
};

export const getServerSideProps: GetServerSideProps<SatelliteProps> = async () => {
  return {
    props: {
      forecasts: await getAllForecasts(AppConfig.partner.defaultPlace),
      seo: completeSeoData(rawSeoData, AppConfig.partner.defaultPlace),
    },
  };
};

const Satellite = ({ forecasts, seo }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  useStepEvent('SatelliteScreen');

  const place = AppConfig.partner.defaultPlace;
  const otherPlacesForecast = plainToInstance(OtherPlaceForecast, forecasts.other);

  const headingText = `Карта осадков и ветров ${AppConfig.partner.isVl() ? 'Приморского края' : 'Хабаровского края'}`;

  return (
    <Main meta={<Meta title={seo.title} description={seo.description} />}>
      <h1 className="mb-5 mt-4 px-4 text-2xl font-medium text-grey-900 lg:mt-0 lg:px-0">{headingText}</h1>
      <Map lat={place.coordinates.lat} lon={place.coordinates.lon} />
      <OtherPlacesForecastWidget otherPlacesForecast={otherPlacesForecast} />
      <NpsWidgetScript type={NpsTypes.QUESTION} slug={'vl_weather_main'} />
    </Main>
  );
};

export default Satellite;
